import { createTRPCClient, httpBatchLink } from "@trpc/client";
import { getApiUrl } from "./config";
import { authClient } from "./auth-client";

/**
 * Get the current auth token for tRPC requests.
 * Reads from localStorage first, then falls back to Better Auth session.
 */
async function getAuthToken(): Promise<string | null> {
  let token =
    localStorage.getItem("better-auth.session_token") ||
    localStorage.getItem("token");

  if (!token) {
    try {
      if (typeof (authClient as any).getToken === "function") {
        token = await (authClient as any).getToken();
      }
    } catch {
      // ignore
    }

    if (!token) {
      const session = await authClient.getSession();
      if (session?.data) {
        const data = session.data as any;
        token = data.token || data.session?.token;
      }
    }

    if (token) {
      localStorage.setItem("better-auth.session_token", token);
    }
  }

  return token;
}

/**
 * tRPC client for type-safe API calls.
 *
 * Note: The AppRouter type is imported from the API via relative path.
 * At build time, Vite resolves this through fs.allow: [".."].
 * For tsc, we use a type assertion since this is purely a type-level import.
 */
// @ts-ignore - cross-project type import resolved by Vite at build time
import type { AppRouter } from "../../../../api/server/trpc/root.js";

export const trpc = createTRPCClient<AppRouter>({
  links: [
    httpBatchLink({
      url: getApiUrl("/api/trpc"),
      fetch(url, options) {
        return fetch(url, {
          ...options,
          credentials: "include",
        });
      },
      async headers() {
        const token = await getAuthToken();
        return {
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        };
      },
    }),
  ],
});